import {SidebarTrigger} from '@/shadcn_components/ui/sidebar';
import {Separator} from '@radix-ui/react-separator';
import AppBreadcrumbs from './AppBreadcrumbs';
import {NavUser} from './nav-user';
import {NavNotifications} from './nav-notifications';

const Header: React.FC = () => {
  return (
    <header className="border-b-2 bg-gray-50 sticky top-0 z-30 flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
      <div className="w-full flex flex-row items-center px-4">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 h-4" />
        <AppBreadcrumbs />
        <div className="flex-grow" />
        <div className="flex items-center gap-4">
          {/* <NavNotifications /> */}
          <NavUser iconOnly />
        </div>
      </div>
    </header>
  );
};

export default Header;
